module.exports = __webpack_public_path__ + "static/media/GothamRnd-Medium.4518b6f0.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Medium.otf
 ** module id = 1354
 ** module chunks = 0
 **/